module.exports = __webpack_public_path__ + "static/img/triangle_confetti.0d119fa3.png";